import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBSouthProvinceExpo = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Exhibits at the 2025 Southern Province Expo</h1>

                    <p className="pb-3">Indo Zambia Bank was honoured to be a Bronze Sponsor and participant at the Southern Province Expo 2025, held in Livingstone under the theme “Unlocking Investment Opportunities for Socio-Economic Transformation through Partnership and Innovation".</p>

                    <p className="pb-3">Our Board Chairman, Dr. Michael Gondwe, Managing Director, Mr. Brajesh Kumar Singh and General Manager proudly welcomed the Republican President, H.E. Mr. Hakainde Hichilema, to the Indo Zambia Bank stand. During the visit, our General Manager showcased the Bank’s continued strides in the agricultural sector through the Indo Dairy Development and Indo Dairy Production Finance Schemes. These two schemes are designed to close long-standing financial gaps in the dairy value chain. These schemes empower farmers to acquire livestock, develop infrastructure, access veterinary care, and invest in storage and feed supplements to improve productivity and sustainability.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #SouthernExpo2025 #UnlockingInvestment #Partnership #Innovation #Livingstone #IZBFosteringGrowth #SupportingYouDevelopingZambia #LetsGrowTogether</em></b></p>


                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-1.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-2.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-3.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-4.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-5.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-banner-6.jpg" alt="Indo Zambia Bank Exhibits at the 2025 Southern Province Expo" />
                            </div>
                        </Slider>
                    </div>
                </div>



            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBSouthProvinceExpo;
